module.exports = __webpack_public_path__ + "static/media/Relu-Activation-Function.c0c6a349.gif";